import Box from '@mui/material/Box'
import MoneyIcon from '@mui/icons-material/Money'
import CircularProgress from '@mui/material/CircularProgress'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'

import { StepIcon } from './wizard-common'
import { useRenewableSources } from '@/hooks/use-renewable-source'
import { useEffect } from 'react'

import WizardSellElectricityWrapper from '@/components/wizard/sell-electricity-wrapper'

export function WizardStep7({
    nextStep,
    goBack,
    estateId,
}: {
    nextStep: () => void
    goBack: () => void
    estateId: number
}) {

    const { status, data, error } = useRenewableSources(estateId)

    useEffect(() => {
        if (data && data.length == 0) {
            nextStep()
        }
    }, [data])

    if (status === 'pending') {
        return <CircularProgress />
    }

    if (error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{error.message}</Box>
            </Box>
        )
    }

    return (
        <Box>
            <StepIcon icon={<MoneyIcon />} color={'#ffecdb'} />

            <WizardSellElectricityWrapper
                estateId={estateId}
                goBack={goBack}
                nextStep={nextStep}
            />

        </Box>
    )
}
